import { useQueryClient } from "react-query";

const WEBSITE_VALIDATOR_QUERY_KEY = "validate-website-url";
const HEAD_REQUEST_OPTIONS: RequestInit = { method: "HEAD", mode: "no-cors" };

export const useWebsiteValidatorQuery = () => {
  const queryClient = useQueryClient();

  const validateWebsiteReachable = async (url: string): Promise<boolean> => {
    try {
      return await queryClient.fetchQuery(
        [WEBSITE_VALIDATOR_QUERY_KEY, url],
        async () => {
          const response = await fetch(url, HEAD_REQUEST_OPTIONS);
          return response.ok || response.type === "opaque";
        },
      );
    } catch {
      return false;
    }
  };

  return { validateWebsiteReachable };
};
